import React, { useState } from 'react';
import {
  makeStyles,
  Typography,
  Container,
  Box,
  TextField,
} from '@material-ui/core';
import Page from '../../components/Page';
import ButtonSecondary from '../../components/Button/ButtonSecondary';
import ButtonPrimary from '../../components/Button/ButtonPrimary';
import { useHistory } from 'react-router-dom';
import { getCarpark, getCarpark2 } from '../../slices/carpark';
import DialogError from '../../components/DialogError';
import DialogQr from './DialogQr';

const useStyles = makeStyles((theme) => ({
  root: {},
  container: {
    padding: '50px 30px',
    [theme.breakpoints.down('xs')]: {
      padding: '40px 20px',
    }
  },
  img: {
    height: 250,
    width: 'auto',
  },
  text: {
    width: 317,
    [theme.breakpoints.down('xs')]: {
      width: 317,
    }
  },
  imgScan: {
    width: 25,
    height: 25,
    padding: 0,
  },
  boxScan: {
    border: '1px solid #D4DDE3',
    padding: 8,
    paddingBottom: 0,
    borderRadius: 4,
    '&:hover': {
      border: `1px solid ${theme.palette.primary.dark}`,
      cursor: 'pointer',
    }
  }
}));

const Home = () => {
  const classes = useStyles();
  const history = useHistory();

  const [carparkNumber, setCarparkNumber] = useState();
  const [openNotFound, setOpenNotFound] = useState(false);
  const [openQrNotFound, setOpenQrNotFound] = useState(false);
  const [openScan, setOpenScan] = useState(false);

  const [openVideo, setOpenVideo] = useState(false);
  
  const onSubmit = async () => {
    let response = await getCarpark2({
      company: 'T-002',
      branch: '00623',
      deviceKey: 'TCP-H00001',
      ticketId: carparkNumber
    });

    let result = response;
    if (result?.ticketId) {
      history.push(`T-002/00623/H-001/${carparkNumber}`);
    } else {
      setOpenNotFound(true);
    }
  }

  const onSubmitQr = async (ticketId) => {
    let response = await getCarpark(ticketId);
    let result = response;
    if (result?.ticketId) {
      setOpenScan(false);
      history.push(`T-002/00623/H-001/${ticketId}`);
    } else {
      setOpenScan(false);
      setOpenQrNotFound(true);
    }
  }

  return (
    <Page
      className={classes.root}
      title="หน้าหลัก"
    >
      <DialogError
        open={openNotFound}
        onClose={() => setOpenNotFound(false)}
        title="ไม่พบข้อมูล Test"
        text="ไม่พบข้อมูลนี้ในระบบ กรุณากรอกใหม่"
      />

      <DialogError
        open={openQrNotFound}
        onClose={() => setOpenQrNotFound(false)}
        title="QR Code ไม่ถูกต้อง"
        text="QR Code ไม่ถูกต้อง กรุณาสแกนใหม่"
      />

      <DialogQr 
        open={openScan}
        onClose={() => setOpenScan(false)}
        onSubmit={onSubmitQr}
      />

      <Container maxWidth="sm" className={classes.container}>
        {openVideo ? (
          <Box align="center" justifyContent='center'>
            <Box my={4} display="flex" alignItems="center" justifyContent="center" style={{ width: '100%', height: 300, backgroundColor: '#C5BDBD' }}>
              <Typography variant='h3'>ขนาดวิดีโอโฆษณา</Typography>
            </Box>

            <Box display="flex" justifyContent='center' mt={3}>
              <Box ml={2}>
                <ButtonPrimary
                  title="ตรวจสอบ / ชำระค่าบริการจอดรถ"
                  style={{ width: 300 }}
                  onClick={() => setOpenVideo(false)}
                />
              </Box>
            </Box>
          </Box>
        ) : (
        <Box align="center" justifyContent='center'>
          <Typography variant='h4'>ตรวจสอบค่าบริการ</Typography>

          <Box my={4}>
            <img
              alt=""
              src="/static/images/Illustration@2x.png"
              className={classes.img}
            />
          </Box>

          <Box display="flex" justifyContent='center'>
            <Box>
              <TextField
                variant='outlined'
                placeholder='หมายเลขบัตรจอดรถ'
                className={classes.text}
                onChange={(e) => setCarparkNumber(e.target.value)}
                value={carparkNumber}
              />
            </Box>
            {/* <Box ml={1} className={classes.boxScan} onClick={() => setOpenScan(true)}>
              <img
                alt=""
                src="/static/images/Icon metro-qrcode@2x.png"
                className={classes.imgScan}
              />
            </Box> */}
          </Box>

          <Box display="flex" justifyContent='center' mt={3}>
            <ButtonSecondary
              title="ยกเลิก"
              style={{ width: 120 }}
            />
            <Box ml={2}>
              <ButtonPrimary
                title="ตรวจสอบค่าบริการ"
                style={{ width: 180 }}
                disabled={!carparkNumber}
                onClick={() => onSubmit()}
              />
            </Box>
          </Box>
        </Box>
        )}
      </Container>
    </Page>
  );
};

export default Home;